import {ModuleConfiguration} from "../router/model/UserPermission";
import {OpportunityFilterModuleName} from "../utils/names/optionalModuleNames";
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";

export const OpportunityFilterModule = new ModuleConfiguration(OpportunityFilterModuleName, [
    AngularJsMaterialModuleName
]);